import { defineComponent as _defineComponent } from 'vue'
import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import { formatPrice as formatMeters } from "@/helpers/transformation/price";
  import HouseFeatures from "../HouseFeatures.vue";

  interface Props {
    house: HouseDesignInterface;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseDesignCard',
  props: {
    house: {}
  },
  emits: ["view-floor-plan"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;

  const formatPrice = (price: number): string => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  const handleViewFloorPlan = (event: Event) => {
    event.stopPropagation();
    emit("view-floor-plan", props.house._id);
  };

const __returned__ = { props, emit, formatPrice, handleViewFloorPlan, get HouseDesignInterface() { return HouseDesignInterface }, get formatMeters() { return formatMeters }, HouseFeatures }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})